const appSettings = {
  ENVIRONMENT_NAME: 'staging',
  SIGNOZ_TOKEN: 'mXamr4lKnXva055R8X4rjxeaM2vafxSEMR1b', //gitleaks:allow //trufflehog:ignore
  SERVICE_VERSION: '660f5e8a427a5e5de47e2138a6a7fbe59d96e596-staging',
  STACKDRIVER_API_KEY: 'AIzaSyAnL1trIr6wVSkKXoju2JBD_AdAMNflWhM', //gitleaks:allow //trufflehog:ignore
  STACKDRIVER_LOGGING_ENABLED: true,
  GOOGLE_PROJECT_ID: '38104635069',
  GRAPHQL_SERVER_URL: 'https://api-staging.spoileralert.com/admin/',
  REFRESH_URL: 'https://admin-staging.spoileralert.com/version',
  GOOGLE_MAPS_VERSION: '3.37',
  DATABASE_RESET_PROFILE: 'demo',
};

export default appSettings;
